module.exports = new __parcel__URL__("wolf.a39956da.svg").toString();